<template>
  <div class="body" :style="`direction: ${dir};`">
    <v-row>
      <!-- form side — same column split, spacing and card as LoginForm.vue -->
      <v-col cols="12" md="6">
        <div class="mt-10 pa-10 text-center">

          <div class="errorMesg" v-if="error">{{ error }}</div>

          <div class="mt-16"
               :style="`border-radius:10px;color:#FFF;background:rgb(0, 0, 0);margin:auto;direction:${dir};width:300px;border:1px solid #000`">

            <!-- STEP 1 — choose a system -->
            <template v-if="step === 'choose'">
              <div class="text-start pa-3 pb-1">
                <label>{{ t.chooseTitle }}</label>
              </div>
              <div class="pa-3 pt-0" v-if="loadingSystems">
                <div style="color:#FFF;font-size:.9rem">{{ t.loading }}</div>
              </div>
              <div class="pa-3 pt-0" v-else-if="!systems.length">
                <div style="color:#FFF;font-size:.9rem">{{ t.noSystems }}</div>
              </div>
              <div class="pa-3 pt-0" v-else>
                <button v-for="(s, i) in systems" :key="s.code" class="btn btn-success demo-sys-btn"
                        :style="sysStyle(i)" @click="choose(s)">
                  <span class="demo-sys-thumb" :style="`background:${s.accent || '#2563eb'}`">
                    <i class="mdi" :class="s.icon || 'mdi-application'"></i>
                    <img v-if="s.image" :src="s.image" alt=""
                         @error="$event.target.style.display = 'none'" />
                  </span>
                  <span class="demo-sys-label">{{ lang.langname === 'en' ? s.name_en : s.name_ar }}</span>
                </button>
              </div>
            </template>

            <!-- STEP 2 — visitor details -->
            <template v-else-if="step === 'details'">
              <div class="text-start pa-3 pb-1">
                <label>{{ chosenName }}</label>
              </div>
              <div class="text-start pa-3 pt-0">
                <label for="demo_name">{{ t.fullName }}</label>
                <b-form-input id="demo_name" v-model="form.full_name" :placeholder="t.fullName" trim />
              </div>
              <div class="text-start pa-3 pt-0">
                <label for="demo_business">{{ t.business }}</label>
                <b-form-input id="demo_business" v-model="form.business_name" :placeholder="t.business" trim />
              </div>
              <div class="text-start pa-3 pt-0">
                <label for="demo_mobile">{{ t.mobile }}</label>
                <b-form-input id="demo_mobile" v-model="form.mobile" type="tel" dir="ltr"
                              :placeholder="t.mobilePh" @keyup.native.enter="sendOtp()" trim />
                <div style="font-size:.75rem;color:#84c8ff;margin-top:4px">{{ t.mobileHint }}</div>
              </div>

              <div style="margin:20px 5px;display:flex;justify-content: center;justify-items: center;">
                <b-button type="button" class="bgbalck" :disabled="busy" @click="sendOtp()"
                          style="font-size: small;width:50%;background:#84c8ff !important;color:#000 !important;font-weight:bolder">
                  {{ busy ? t.sending : t.sendCode }}&nbsp;&nbsp;<i class="fas fa-paper-plane"></i>
                </b-button>
              </div>
              <div class="pa-3 pt-0 text-center">
                <a href="#" class="demo-back" @click.prevent="backToChoose">{{ t.back }}</a>
              </div>
            </template>

            <!-- STEP 3 — OTP -->
            <template v-else-if="step === 'otp'">
              <div class="text-start pa-3 pb-1">
                <label>{{ t.otpTitle }}</label>
                <div style="font-size:.8rem;color:#84c8ff">{{ t.otpCopy }} <span dir="ltr">{{ maskedMobile }}</span></div>
              </div>
              <div class="text-start pa-3 pt-0">
                <b-form-input id="demo_otp" v-model="otpCode" type="tel" maxlength="6" dir="ltr"
                              class="demo-otp-input" placeholder="------"
                              @keyup.native.enter="verifyOtp()" trim />
              </div>

              <div style="margin:20px 5px;display:flex;justify-content: center;justify-items: center;">
                <b-button type="button" class="bgbalck" :disabled="busy || otpDigits.length !== 6" @click="verifyOtp()"
                          style="font-size: small;width:50%;background:#84c8ff !important;color:#000 !important;font-weight:bolder">
                  {{ busy ? t.verifying : t.enterDemo }}&nbsp;&nbsp;<i class="fas fa-sign-in-alt"></i>
                </b-button>
              </div>

              <div class="pa-3 pt-0 text-center" style="font-size:.8rem;color:#84c8ff">
                <span v-if="countdown > 0">{{ t.resendIn }} {{ countdown }}{{ t.seconds }}</span>
                <a v-else href="#" class="demo-back" @click.prevent="sendOtp(true)">{{ t.resend }}</a>
              </div>
              <div class="pa-3 pt-0 text-center">
                <a href="#" class="demo-back" @click.prevent="step = 'details'">{{ t.back }}</a>
              </div>
            </template>

            <!-- STEP 4 — done -->
            <template v-else>
              <div class="pa-4 text-center">
                <i class="fas fa-check-circle" style="font-size:2rem;color:#84c8ff"></i>
                <div style="margin-top:10px">{{ t.welcome }}</div>
                <div style="font-size:.8rem;color:#84c8ff;margin-top:6px">{{ t.redirecting }}</div>
              </div>
            </template>

            <!-- language switch — identical to LoginForm -->
            <div class="text-start pa-3 pt-0" style="direction:rtl">
              <button class="btn btn-success" id="arabic" @click="changeLang('ar')"
                      style="border:1px solid #000;background:#84c8ff;width:50%;border-radius:0;color:#000 !important;font-weight:bolder">عربي</button>
              <button class="btn btn-success" id="english" @click="changeLang('en')"
                      style="border:1px solid #000;background:#eee;color:#000;width:50%;border-radius:0;font-weight:bolder">English</button>
            </div>

          </div>

          <div class="text-center" style="color:black">SAMCOTEC V {{ $store.state.Version }}</div>
          <div class="loginSupport">{{ lang.for_more_information_or_support_firstline }}</div>
          <div class="loginSupport" style="padding:5px;border:1px solid #000;background:#FFF;">{{ lang.for_more_information_or_support_secondline }}</div>
        </div>
      </v-col>

      <!-- brand side — copied from LoginForm.vue so the two pages are indistinguishable -->
      <v-col cols="12" md="6"
             style="position:relative;background:#fff;color:#000;height:100vh;margin-top:-3px;border-bottom:3px solid #84c8ff;border-top:3px solid #84c8ff;border-right:3px solid #000;border-left:3px solid #84c8ff">
        <div class="pa-5 mt-16 text-center" style="padding-top:25% !important">
          <img :src="`../img/samcotec-logo.png`" v-if="!$store.state.licenseType.cars && lang.langname != 'ur'" style="width:130px;">
          <img :src="`../img/urdo-logo.jpeg`" v-else-if="lang.langname == 'ur'" style="width:130px;">
          <img :src="`../img/${$store.state.logo}`" v-else style="width:130px;">
        </div>
        <div class="pa-5 mt-16 text-center" style="padding-top:10px !important">
          <img :src="`../img/safip.png`" style="width:200px" />
          <div style="margin-top:10px;text-align: center;">
            <div style="margin-top:10px;text-align: center;"><span style="color:red">تحذيـر </span>
              يمنع إعادة إنتاج البرنامج وملحقاته بشكل كامـل أو تقليـده دون زيـادة أو نقصان أو أجراء أي تعديل عليه
              هذا المنتج تملكة شركة سام لتقنية المعلومات المحدوده – الرياض بموجب العلامه التجارية SAMCOTEC
            </div>
            <div style="margin-top:10px;text-align: center;">
              باعتماد الهيئة السعودية للملكية الفكرية برقم: 1435022395 وتاريخ 05-01-1436
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'

/**
 * Public demo portal.
 *
 * Presentation is deliberately identical to components/LoginForm.vue — same
 * shell, card, palette, language switch and brand column — so a visitor cannot
 * tell the demo entry point from the product's own login screen.
 *
 * Flow: pick a system, give a name and a WhatsApp number, receive a code, and
 * land inside that system's demo database as an accountant. No password is ever
 * shown or typed; the server regenerates one per verification and the client
 * only handles the resulting session hash.
 */
export default {
  name: 'DemoPortal',

  data () {
    return {
      step: 'choose',            // choose | details | otp | done
      systems: [],
      loadingSystems: true,
      chosen: { code: '', name_ar: '', name_en: '' },
      form: { full_name: '', business_name: '', mobile: '' },
      otpCode: '',
      busy: false,
      error: '',
      countdown: 0,
      timer: null,
      ip: ''
    }
  },

  computed: {
    // Same resolution LoginForm.vue uses, so the demo follows the app language.
    lang () {
      const cookie = this.$cookies.get(this.$store.state.LangCooki)
      if (cookie === 'en') return this.$store.state.lang.en
      if (cookie === 'ur') return this.$store.state.lang.ur
      if (cookie == null && this.$store.state.deflang === 'en') return this.$store.state.lang.en
      return this.$store.state.lang.ar
    },

    dir () { return this.lang.dir || 'rtl' },

    chosenName () {
      return this.lang.langname === 'en' ? this.chosen.name_en : this.chosen.name_ar
    },

    otpDigits () { return (this.otpCode || '').replace(/\D/g, '') },

    // Deliberately permissive — the authoritative check is the server asking
    // WhatsApp whether the number exists. This only catches obvious typos.
    mobileLooksValid () {
      const d = (this.form.mobile || '').replace(/\D/g, '')
      return d.length >= 9 && d.length <= 15
    },

    maskedMobile () {
      const d = (this.form.mobile || '').replace(/\D/g, '')
      return d.length < 4 ? d : d.slice(0, 3) + '****' + d.slice(-3)
    },

    t () {
      const ar = {
        chooseTitle: 'اختر النظام التجريبي',
        loading: 'جاري التحميل...',
        noSystems: 'لا توجد أنظمة متاحة حالياً',
        fullName: 'الاسم',
        business: 'اسم الورشة أو المحل',
        mobile: 'رقم الواتساب',
        mobilePh: '05XXXXXXXX',
        mobileHint: 'يجب أن يكون الرقم مفعّل على واتساب',
        sendCode: 'إرسال الرمز',
        sending: 'جاري الإرسال',
        otpTitle: 'رمز التحقق',
        otpCopy: 'أرسلنا رمزاً إلى',
        enterDemo: 'دخول',
        verifying: 'جاري التحقق',
        resendIn: 'إعادة الإرسال بعد',
        seconds: ' ثانية',
        resend: 'إعادة إرسال الرمز',
        back: 'رجوع',
        welcome: 'تم التحقق بنجاح',
        redirecting: 'جاري تجهيز النسخة التجريبية...',
        errors: {
          system_required: 'اختر النظام أولاً',
          name_required: 'الاسم مطلوب',
          mobile_invalid: 'رقم الجوال غير صحيح',
          not_whatsapp_number: 'هذا الرقم غير مسجّل على واتساب',
          system_not_found: 'النظام غير متاح حالياً',
          otp_recently_sent: 'تم إرسال رمز قبل قليل، انتظر قليلاً',
          too_many_requests: 'محاولات كثيرة، حاول بعد قليل',
          otp_not_found: 'لا يوجد رمز فعّال، اطلب رمزاً جديداً',
          otp_expired: 'انتهت صلاحية الرمز، اطلب رمزاً جديداً',
          otp_invalid: 'الرمز غير صحيح',
          otp_attempts_exceeded: 'تجاوزت عدد المحاولات، اطلب رمزاً جديداً',
          demo_database_misconfigured: 'النسخة التجريبية غير مهيأة، تواصل معنا',
          demo_group_must_not_be_admin: 'إعداد الصلاحيات غير صحيح',
          demo_user_not_created: 'تعذّر تجهيز الحساب التجريبي',
          network: 'تعذّر الاتصال بالخادم، حاول مرة أخرى'
        }
      }
      const en = {
        chooseTitle: 'Choose a demo system',
        loading: 'Loading...',
        noSystems: 'No systems available',
        fullName: 'Name',
        business: 'Workshop or shop name',
        mobile: 'WhatsApp number',
        mobilePh: '05XXXXXXXX',
        mobileHint: 'Must be an active WhatsApp number',
        sendCode: 'Send code',
        sending: 'Sending',
        otpTitle: 'Verification code',
        otpCopy: 'We sent a code to',
        enterDemo: 'Enter',
        verifying: 'Verifying',
        resendIn: 'Resend in',
        seconds: 's',
        resend: 'Resend code',
        back: 'Back',
        welcome: 'Verified',
        redirecting: 'Preparing your demo...',
        errors: {
          system_required: 'Choose a system first',
          name_required: 'Your name is required',
          mobile_invalid: 'That mobile number is not valid',
          not_whatsapp_number: 'That number is not on WhatsApp',
          system_not_found: 'That system is not available',
          otp_recently_sent: 'A code was just sent, please wait',
          too_many_requests: 'Too many attempts, try again shortly',
          otp_not_found: 'No active code, request a new one',
          otp_expired: 'That code expired, request a new one',
          otp_invalid: 'That code is not correct',
          otp_attempts_exceeded: 'Too many attempts, request a new code',
          demo_database_misconfigured: 'This demo is not configured, contact us',
          demo_group_must_not_be_admin: 'Demo role is misconfigured',
          demo_user_not_created: 'Could not prepare the demo account',
          network: 'Could not reach the server, please try again'
        }
      }
      return this.lang.langname === 'en' ? en : ar
    }
  },

  methods: {
    // Alternating fill mirrors the branch buttons on the login screen.
    sysStyle (i) {
      const bg = i % 2 === 0 ? '#84c8ff' : '#eee'
      return `border:1px solid #000;background:${bg};width:100%;border-radius:0;color:#000 !important;font-weight:bolder;margin-bottom:4px;font-size:.95rem;display:flex;align-items:center;gap:8px;text-align:start;padding:6px`
    },

    changeLang (id) {
      this.$cookies.set(this.$store.state.LangCooki, id)
      this.$store.state.deflang = id
      this.$forceUpdate()
    },

    describe (code) { return this.t.errors[code] || code || this.t.errors.network },

    post (type, extra) {
      const fd = new FormData()
      fd.append('type', type)
      Object.keys(extra || {}).forEach(k => fd.append('data[' + k + ']', extra[k]))
      return axios.post(this.$store.state.SAMCOTEC.r_path, fd).then(r => r.data)
    },

    loadSystems () {
      this.loadingSystems = true
      this.post('getDemoSystems', {}).then(res => {
        this.systems = (res && res.results) || []
      }).catch(() => {
        this.error = this.t.errors.network
      }).then(() => {
        this.loadingSystems = false
      })
    },

    choose (s) {
      this.chosen = s
      this.error = ''
      this.step = 'details'
    },

    backToChoose () {
      this.step = 'choose'
      this.error = ''
    },

    sendOtp (isResend) {
      if (this.busy) return
      if (!this.form.full_name) { this.error = this.t.errors.name_required; return }
      if (!this.mobileLooksValid) { this.error = this.t.errors.mobile_invalid; return }

      this.busy = true
      this.error = ''

      this.post('requestDemoOtp', {
        system_code: this.chosen.code,
        full_name: this.form.full_name,
        business_name: this.form.business_name,
        mobile: this.form.mobile
      }).then(res => {
        if (res && res.error && Number(res.error.number) === 200) {
          this.step = 'otp'
          this.otpCode = ''
          this.startCountdown((res.results && res.results.resend_after) || 60)
        } else {
          this.error = this.describe(res && res.error && res.error.message)
        }
      }).catch(() => {
        this.error = this.t.errors.network
      }).then(() => {
        this.busy = false
      })
    },

    verifyOtp () {
      if (this.busy || this.otpDigits.length !== 6) return
      this.busy = true
      this.error = ''

      this.post('verifyDemoOtp', {
        system_code: this.chosen.code,
        mobile: this.form.mobile,
        otp_code: this.otpDigits
      }).then(res => {
        if (res && res.error && Number(res.error.number) === 200) {
          this.step = 'done'
          this.establishSession(res.results)
        } else {
          this.error = this.describe(res && res.error && res.error.message)
          this.otpCode = ''
        }
      }).catch(() => {
        this.error = this.t.errors.network
      }).then(() => {
        this.busy = false
      })
    },

    /**
     * Same cookie contract the normal login uses (ID||hash||ip||time), so from
     * here on the demo user is an ordinary session and every existing guard
     * keeps working without a special case.
     */
    establishSession (results) {
      const code = results.data.ID + '||' + results.hash + '||' + this.ip + '||' + results.time
      this.$cookies.set(this.$COOKIEPhase, code, 86400)
      setTimeout(() => { window.location.href = results.data.redirect || '/' }, 1200)
    },

    startCountdown (seconds) {
      this.countdown = seconds
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) { clearInterval(this.timer); this.timer = null }
      }, 1000)
    },

    getIp () {
      const url = this.$SAMCOTEC && this.$SAMCOTEC.ip_url
      if (!url) return
      // The IP only decorates the session cookie; if the lookup is unreachable
      // the demo still works, so a failure is deliberately ignored.
      axios.get(url)
        .then(r => { this.ip = (r.data && r.data.ip) || '' })
        .catch(() => { this.ip = '' })
    }
  },

  mounted () {
    this.loadSystems()
    this.getIp()
  },

  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style>
/* Identical to components/LoginForm.vue — intentionally unscoped and duplicated
   so the demo page renders the same whether or not the login chunk is loaded. */
.body{
  border:3px inset #000;
  background:#84c8ff !important;
  color:#000;
  height: 100vh;
}
.bgbalck{
  background:rgb(0,0,0) !important;
  color:#FFF !important;
}
.errorMesg{
  background:rgba(0, 0, 0,0.5);
  padding:5px;
  width:50%;
  margin:auto;
  border-radius: .8rem;
  color:#FFF;
}
.loginSupport{
  z-index:4000;
  margin-top:10px;
  bottom: 0px;
  left: 0;
  right:0;
  padding:5px;
  text-align:center;
  font-size:1.2rem;
  color:#000;
}
.demo-back{
  color:#84c8ff !important;
  font-size:.8rem;
  text-decoration:underline;
}
.demo-otp-input{
  text-align:center;
  letter-spacing:.5rem;
  font-size:1.2rem;
  font-weight:bolder;
}
.demo-sys-btn{
  display:block;
}
.demo-sys-thumb{
  position:relative;
  width:36px;
  height:36px;
  min-width:36px;
  border-radius:6px;
  display:flex;
  align-items:center;
  justify-content:center;
  overflow:hidden;
  color:#FFF;
  font-size:1.1rem;
}
.demo-sys-thumb img{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
}
.demo-sys-label{
  flex:1;
}
</style>
